import { ArrowRight, Bot, Globe2, LineChart, MessageSquareText, Route } from "lucide-react";
import { Link } from "react-router-dom";

const PORTAL_MOCKUP_URL = "https://static.prod-images.emergentagent.com/jobs/4bc8a89a-e1c9-462b-87e6-ef6be029552e/images/09e755d5d8ef4324fdc59dcd0e97c768a6d8a489358e5dc6f1215225d1a42e58.png";

const PRO_PLAN_FEATURES = [
  { key: "portal", title: "Own branded portal", icon: Globe2 },
  { key: "chatbot", title: "AI chatbot", icon: Bot },
  { key: "follow-ups", title: "Automated follow-ups", icon: Route },
  { key: "analytics", title: "Real-time analytics", icon: LineChart },
  { key: "reports", title: "AI property reports", icon: MessageSquareText },
];

export const AgentProofTeaser = ({ buildBrandedPath, openLivePortal }) => (
  <section className="section-shell pt-8" data-testid="homepage-agent-proof-section">
    <div className="overflow-hidden rounded-[36px] border border-[#D7C39A]/45 bg-[linear-gradient(180deg,#FFFDF7_0%,#F8F1E3_100%)] p-8 shadow-[0_28px_90px_rgba(12,40,90,0.08)] lg:p-10">
      <div className="grid gap-8 lg:grid-cols-[0.88fr_1.12fr] lg:items-center">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#8b6d16]">Agent Proof</p>
          <h2 className="mt-3 text-4xl font-semibold leading-tight text-[#0C285A] md:text-5xl" data-testid="homepage-agent-proof-heading">
            Are you an agent? Build your own branded portal with Pro Plan.
          </h2>
          <p className="mt-4 text-sm leading-8 text-[#42566f] md:text-base" data-testid="homepage-agent-proof-copy">
            Keep 100% of your leads, use a 24/7 AI assistant, and strengthen your branding without relying only on shared portals.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <button className="gold-button" data-testid="homepage-agent-proof-live-demo-button" onClick={openLivePortal} type="button">
              View Live Sample Portal <ArrowRight className="ml-2 h-4 w-4" />
            </button>
            <Link className="outline-button !border-[#0C285A]/16 !text-[#0C285A] hover:!bg-[#0C285A]/5" data-testid="homepage-agent-proof-page-button" to={buildBrandedPath("/for-agents")}>
              Explore For Agents
            </Link>
            <Link className="outline-button !border-[#0C285A]/16 !text-[#0C285A] hover:!bg-[#0C285A]/5" data-testid="homepage-agent-proof-pricing-button" to={buildBrandedPath("/pricing")}>
              Review Pro Plan
            </Link>
          </div>
        </div>

        <div className="grid gap-5 lg:grid-cols-[1.05fr_0.95fr]">
          <div className="overflow-hidden rounded-[28px] border border-[#D7C39A]/36 bg-white/72 p-3" data-testid="homepage-agent-proof-mockup-frame">
            <div className="rounded-[22px] border border-[#0C285A]/10 bg-[#102F5D] p-3">
              <img alt="SG Prop Portal agent portal mockup" className="aspect-[1.18/1] w-full rounded-[18px] object-cover" data-testid="homepage-agent-proof-mockup-image" src={PORTAL_MOCKUP_URL} />
            </div>
          </div>

          <div className="grid gap-3" data-testid="homepage-agent-proof-feature-grid">
            {PRO_PLAN_FEATURES.map((feature) => {
              const Icon = feature.icon;
              return (
                <div className="rounded-[24px] border border-[#D7C39A]/36 bg-white/72 px-4 py-4" data-testid={`homepage-agent-proof-feature-${feature.key}`} key={feature.key}>
                  <div className="flex items-center gap-3">
                    <div className="rounded-full border border-[#B8860B]/22 bg-[#FFF4DB] p-2.5 text-[#B8860B]">
                      <Icon className="h-4 w-4" />
                    </div>
                    <p className="text-sm font-semibold text-[#0C285A]">{feature.title}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  </section>
);